import { gtmConfig } from '@libs/analytics';
import { getENV } from '@libs/common-next';

export function GtmScript() {
    const { gtmAuth, gtmPreview, gtmContainerId } = gtmConfig[getENV('NEXT_PUBLIC_LOCALE') == 'en-CA' ? 'ca' : 'us'];

    return (
        <script
            id="gtm-script"
            dangerouslySetInnerHTML={{
                __html: `
(function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),
    dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.onload = function() {
        console.log('GTM Loaded at', Date.now());
        w[l].push({event: 'loaded-gtm'})
    }
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x';
    f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmContainerId}');
`,
            }}
        />
    );
}
